module.exports = __webpack_public_path__ + "static/far-cry_plate-0e6a10fda1055dac21b59e389d5eb34e.avif";